<!-- components/AddressSearch/AddressSearch.vue -->
<template>
  <div class="address-search">
    <VAutocomplete
      v-model="selectedAddressId"
      :items="suggestions"
      :loading="isSearching"
      :search="searchQuery"
      label="Search Address"
      placeholder="Start typing address or postcode..."
      variant="outlined"
      density="comfortable"
      prepend-inner-icon="mdi-magnify"
      item-title="text"
      item-value="id"
      clearable
      hide-no-data
      :menu-props="{ maxHeight: 300 }"
      @update:search="onSearch"
      @update:model-value="onSelect"
    >
      <template #item="{ props, item }">
        <VListItem v-bind="props">
          <template #title>
            <div class="d-flex align-center">
              <VIcon size="small" class="mr-2" :color="item.raw.isContainer ? 'primary' : 'grey'">
                {{ item.raw.isContainer ? 'mdi-folder' : 'mdi-map-marker' }}
              </VIcon>
              <span>{{ item.raw.text }}</span>
            </div>
          </template>
          <template #subtitle>
            <span class="text-caption">{{ item.raw.description }}</span>
          </template>
        </VListItem>
      </template>

      <template #append-item>
        <div v-if="isSearching" class="pa-2 text-center">
          <VProgressCircular indeterminate size="20" width="2" />
        </div>
      </template>
    </VAutocomplete>
  </div>
</template>

<script>
// Service
import AddressService from '@/services/address-service/address.service';
export default {
  name: 'AddressSearch',
  props: {
    country: {
      type: String,
      default: 'GBR'
    }
  },
  emits: ['address-selected'],
  data() {
    return {
      searchQuery: '',
      selectedAddressId: null,
      suggestions: [],
      isSearching: false,
      debounceTimer: null
    };
  },
  watch: {
    country() {
      this.suggestions = [];
      this.selectedAddressId = null;
    }
  },
  beforeUnmount() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
  },
  methods: {
    onSearch(query) {
      this.searchQuery = query;
      if (this.debounceTimer) clearTimeout(this.debounceTimer);

      if (!query || query.length < 3) {
        this.suggestions = [];
        return;
      }

      this.debounceTimer = setTimeout(() => {
        this.performSearch(query);
      }, 300);
    },

    async performSearch(query) {
      this.isSearching = true;
      try {
        const result = await AddressService.findAddress(query, this.country);
        this.suggestions = result.items ?? [];
      } finally {
        this.isSearching = false;
      }
    },

    async onSelect(id) {
      if (!id) return;

      const item = this.suggestions.find((s) => s.id === id);
      if (!item) return;

      if (item.isContainer) {
        this.searchQuery = item.text;
        await this.performSearch(item.text);
        this.selectedAddressId = null;
        return;
      }

      const result = await AddressService.retrieveAddress(id);
      if (result.success) {
        this.$emit('address-selected', {
          address1: result.address.address1 || '',
          address2: result.address.address2 || '',
          city: result.address.city || '',
          state: result.address.state || '',
          postcode: result.address.postcode || ''
        });
      }
      this.searchQuery = '';
      this.selectedAddressId = null;
      this.suggestions = [];
    }
  }
};
</script>
